.container-editable:hover .timestamp,
.container-open .timestamp {
    text-decoration: underline;
    color: var(--grey-dk);
}
